export default __webpack_public_path__ + "static/media/projTrack8.2aa433b8.png";